/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Spelling_Numbers_FailedInputs */



/**
* | output |
* | --- |
* | "Spelling numbers #0-10 failed. {error}" |
*
* @param {Spelling_Numbers_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spelling_numbers_failed = /** @type {((inputs: Spelling_Numbers_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spelling_Numbers_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Épellation des chiffres #0-10 échouée. ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Eingabe der Zahlen 0-10 ist fehlgeschlagen. ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Errore nell'ortografia dei numeri da 0 a 10. ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Неправильное написание цифр от 0 до 10. ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al deletrear los números del 0 al 10. ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`数字 0-10 拼写错误。${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`数字 #0-10 のスペルに失敗しました。${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`संख्या 0-10 की वर्तनी में त्रुटि हुई। ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`A soletração dos números de 0 a 10 falhou. ${i?.error}`)
	return /** @type {LocalizedString} */ (`Spelling numbers #0-10 failed. ${i?.error}`)
});